import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUnarchiveDiscount(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const unarchiveDiscount = (discountId: string): Promise<AxiosResponse<null>> => {
    return client.put(`discounts/${discountId}/unarchive/`);
  };

  return useMutation(unarchiveDiscount, {
    onSuccess: () => {
      queryClient.invalidateQueries('discounts');
    },
  });
}
